import ImageAcrylicDisplay from '@/assets/images/fixtures/acrylic-display.jpg';
import ImageIpLabelOrderCardRackFull from '@/assets/images/fixtures/ip-label-order-card-rack-full.jpg';
import ImageIpLabelOrderCardRackHalf from '@/assets/images/fixtures/ip-label-order-card-rack-half.jpg';
import ImageSnapDrinkDisplay from '@/assets/images/fixtures/snap-drink-display.jpg';
import ImageSnapDrinkLeaflet from '@/assets/images/fixtures/snap-drink-leaflet.jpg';

import {
  DrinkMaterialTypeEnum,
  OrganizationContractStatusEnum,
  OrganizationRegisterStatusEnum,
} from '../types';

const ORGANIZATION_REGISTER_STATUS_TEXTS = {
  [OrganizationRegisterStatusEnum['unregistered']]: '未登録',
  [OrganizationRegisterStatusEnum['registered']]: '登録済み',
} as const;

const ORGANIZATION_CONTRACT_STATUS_CONTENTS = {
  [OrganizationContractStatusEnum['under-contract']]: {
    text: '契約中',
    status: 'success',
  },
  [OrganizationContractStatusEnum['outside-contract']]: {
    text: '契約外',
    status: 'error',
  },
} as const;

const ORGANIZATION_CONTRACT_STATUS_OPTIONS = [
  {
    label: ORGANIZATION_CONTRACT_STATUS_CONTENTS['under-contract'].text,
    value: OrganizationContractStatusEnum['under-contract'],
  },
  {
    label: ORGANIZATION_CONTRACT_STATUS_CONTENTS['outside-contract'].text,
    value: OrganizationContractStatusEnum['outside-contract'],
  },
] as const;

const ORGANIZATION_ACODE_STATUS_OPTIONS = [
  {
    label: ORGANIZATION_REGISTER_STATUS_TEXTS.unregistered,
    value: OrganizationRegisterStatusEnum['unregistered'],
  },
  {
    label: ORGANIZATION_REGISTER_STATUS_TEXTS.registered,
    value: OrganizationRegisterStatusEnum['registered'],
  },
] as const;

const ORGANIZATION_BENEFICIARY_ACCOUNT_STATUS_OPTIONS = [
  {
    label: ORGANIZATION_REGISTER_STATUS_TEXTS.unregistered,
    value: OrganizationRegisterStatusEnum['unregistered'],
  },
  {
    label: ORGANIZATION_REGISTER_STATUS_TEXTS.registered,
    value: OrganizationRegisterStatusEnum['registered'],
  },
] as const;

const INVOICE_OR_SALE_FIGURE_TYPES_OPTIONS = [
  { label: 'チェーン一括', value: 'report-for-chain' },
  { label: '店舗ごと', value: 'report-for-each-store' },
] as const;

const PRINTER_ITEM = { name: 'printer_quantity', label: 'プリンタ' } as const;

const FIXTURES_ITEMS = [
  {
    name: 'acrylic_fixture_quantity',
    label: 'アクリルディスプレイ',
    image: ImageAcrylicDisplay,
    alt: 'acrylic display',
  },
  {
    name: 'card_rack_half_fixture',
    label: '[IPラベル]注文用カードラック（ハーフ）',
    image: ImageIpLabelOrderCardRackHalf,
    alt: 'ip label order card rack half',
    note: '*写真はハーフ什器＋アクリルディスプレイのセットです。\n*注文用カード付属',
  },
  {
    name: 'card_rack_for_order_fixture',
    label: '[IPラベル]注文用カードラック（フル）',
    image: ImageIpLabelOrderCardRackFull,
    alt: 'ip label order card rack full',
    note: '*注文用カード付属',
  },
  {
    name: 'card_leaflet_fixture_quantity',
    label: '[SnapDrink]リーフレット',
    image: ImageSnapDrinkLeaflet,
    alt: 'snap drink leaflet',
  },
  {
    name: 'card_rack_full_fixture_quantity',
    label: '[SnapDrink]立型什器',
    image: ImageSnapDrinkDisplay,
    alt: 'snap drink display',
    note: '*１つにつきアクリルディスプレイ2つが同送されます。',
  },
] as const;

const MATERIAL_TABLE_LABELS = {
  ドリンク: DrinkMaterialTypeEnum.drink,
  インク: DrinkMaterialTypeEnum.ink,
  ラベル: DrinkMaterialTypeEnum.label,
  その他: DrinkMaterialTypeEnum.other,
};

const DELIVERY_TIME_ZONE = [
  { value: '8:00-12:00(午前中)' },
  { value: '14:00-16:00' },
  { value: '16:00-18:00' },
  { value: '18:00-20:00' },
];

export {
  DELIVERY_TIME_ZONE,
  FIXTURES_ITEMS,
  INVOICE_OR_SALE_FIGURE_TYPES_OPTIONS,
  MATERIAL_TABLE_LABELS,
  ORGANIZATION_ACODE_STATUS_OPTIONS,
  ORGANIZATION_BENEFICIARY_ACCOUNT_STATUS_OPTIONS,
  ORGANIZATION_CONTRACT_STATUS_CONTENTS,
  ORGANIZATION_CONTRACT_STATUS_OPTIONS,
  PRINTER_ITEM,
};
